/**
 * RFC 7636 S256 PKCE for the SPA. Verifier stays in this tab (sessionStorage)
 * across the Google redirect — never localStorage, never on the callback URL.
 */
function b64url(bytes) {
  let bin = '';
  const arr = bytes instanceof Uint8Array ? bytes : new Uint8Array(bytes);
  for (let i = 0; i < arr.length; i += 1) bin += String.fromCharCode(arr[i]);
  return btoa(bin).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
}

export async function generatePkcePair() {
  const raw = new Uint8Array(32);
  crypto.getRandomValues(raw);
  const verifier = b64url(raw);
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(verifier));
  const challenge = b64url(new Uint8Array(digest));
  return { verifier, challenge, method: 'S256' };
}

const VERIFIER_KEY = 'sso_pkce_verifier';
const REDIRECT_KEY = 'sso_pkce_redirect';

export function persistPkceForRedirect(verifier, redirectUri) {
  try {
    sessionStorage.setItem(VERIFIER_KEY, verifier);
    sessionStorage.setItem(REDIRECT_KEY, redirectUri || '');
  } catch (_) {
    /* private mode */
  }
}

export function takePkceForExchange() {
  let verifier = '';
  let redirectUri = '';
  try {
    verifier = sessionStorage.getItem(VERIFIER_KEY) || '';
    redirectUri = sessionStorage.getItem(REDIRECT_KEY) || '';
    sessionStorage.removeItem(VERIFIER_KEY);
    sessionStorage.removeItem(REDIRECT_KEY);
  } catch (_) {
    /* ignore */
  }
  return { verifier, redirectUri };
}
